import { render, staticRenderFns } from "./ViewSettings.vue?vue&type=template&id=3731a491&scoped=true&"
import script from "./ViewSettings.vue?vue&type=script&lang=js&"
export * from "./ViewSettings.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettings.vue?vue&type=style&index=0&id=3731a491&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731a491",
  null
  
)

export default component.exports